import type { EditorContentRoleValue } from '@messenger/lotus/row-store'

export const PARAGRAPH_ROLE_LABELS: Record<EditorContentRoleValue, string> = {
  body: 'Body',
  heading: 'Heading',
  deceased_name: 'Deceased name',
  subheading: 'Subheading',
  footer: 'Footer',
}

export const orderedRoles = <
  const T extends readonly EditorContentRoleValue[] &
    ([EditorContentRoleValue] extends [T[number]] ? unknown : never),
>(
  order: T,
): T => order
